export const GAME_CAROUSEL_VISIBLE = 5

export default {
  data () {
    return {
      carouselExpanded: false,
      carouselIndex: 0
    }
  },
  computed: {
    carouselItemCount () {
      return this.carouselItems.length
    },
    carouselMaxIndex () {
      return Math.max(0, this.carouselItemCount - GAME_CAROUSEL_VISIBLE)
    },
    carouselCanPrev () {
      return !this.carouselExpanded && this.carouselIndex > 0
    },
    carouselCanNext () {
      return !this.carouselExpanded && this.carouselIndex < this.carouselMaxIndex
    },
    carouselShowNav () {
      return !this.carouselExpanded && this.carouselItemCount > GAME_CAROUSEL_VISIBLE
    },
    carouselTrackStyle () {
      if (this.carouselExpanded || !this.carouselShowNav) return null
      return {
        '--carousel-offset': this.carouselIndex,
        transform: 'translate3d(calc(-1 * var(--carousel-offset) * ((100cqw - (var(--games-visible) - 1) * var(--games-gap)) / var(--games-visible) + var(--games-gap))), 0, 0)',
        transitionDuration: '0.42s'
      }
    }
  },
  watch: {
    carouselItemCount () {
      this.carouselIndex = 0
    }
  },
  methods: {
    toggleCarouselExpanded () {
      this.carouselExpanded = !this.carouselExpanded
      if (!this.carouselExpanded) {
        this.carouselIndex = 0
      }
    },
    carouselPrev () {
      if (this.carouselCanPrev) {
        this.carouselIndex -= 1
      }
    },
    carouselNext () {
      if (this.carouselCanNext) {
        this.carouselIndex += 1
      }
    }
  }
}
